import { render, staticRenderFns } from "./AudienceNotesPanelIcon.vue?vue&type=template&id=e9b53cf4"
import script from "./AudienceNotesPanelIcon.vue?vue&type=script&lang=js"
export * from "./AudienceNotesPanelIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports